<script setup lang="ts">
import type {
  EditorialContainerProps,
  PaddingOptionsType,
} from './EditorialContainer.props'

const props = defineProps<EditorialContainerProps>()
const { isLogged } = useLogin()
const logicWrapperCollection = ref()

if (!props.data) {
  const { data, error }: any = await useLogicWrapperCollection(
    props.deliveryKey as string
  )
  logicWrapperCollection.value = data?.value?.content ? data.value.content : {}

  if (error.value) {
    throw createError({
      statusCode: 404,
      statusMessage: 'Page Not Found',
    })
  }
} else {
  logicWrapperCollection.value = props.data
}
const widthOptions: any = {
  '100': 'w-full',
  '50': 'w-1/2',
  '33': 'w-1/3',
  '25': 'w-1/4',
}

const paddingOptions: Record<PaddingOptionsType, string> = {
  center: 'xl:py-6xl xl:px-36 lg:px-28 md:py-4xl md:px-36 py-lg px-[4.37rem]',
  left: 'xl:py-8xl xl:pr-lg xl:pl-[23rem] lg:py-5xl lg:pr-md lg:pl-48 md:pt-4xl md:pb-3 md:px-[5.3rem] px-[2.65rem] pt-lg pb-xs',
  right:
    'xl:py-8xl xl:pl-lg xl:pr-[23rem] lg:py-5xl lg:pl-md lg:pr-48 md:pb-4xl md:pt-3 md:px-[5.3rem] px-[2.65rem] pt-xs pb-lg',
  fullWidth: 'xl:px-[23rem] lg:px-48 px-sm',
}

const isEditorialTextFullWidth = (arr: unknown) => {
  if (!Array.isArray(arr)) return false

  const editorialTextContent = arr.find(
    (el: unknown) =>
      // @ts-expect-error https://github.com/microsoft/TypeScript/issues/37700
      el?.content?._meta?.schema === 'https://armani.com/editorial-text-module'
  )
  if (!editorialTextContent) return false

  const dimension = parseInt(editorialTextContent.dimension)
  if (isNaN(dimension)) return false

  return dimension >= 100
}
</script>

<template>
  <div v-if="logicWrapperCollection">
    <div
      v-for="(logicWrapper, i) in logicWrapperCollection?.listOfLogicWrapper"
      :key="`logic-wrapper-content-${i}`"
    >
      <div
        v-if="
          logicWrapper.showTo === 'All' ||
          (logicWrapper.showTo === 'Logged' && isLogged) ||
          (logicWrapper.showTo === 'Guest' && !isLogged)
        "
        class="bg-background-secondary border-background-secondary flex flex-col gap-px border-b md:flex-row"
        :class="[
          logicWrapper.verticalOrientation
            ? 'gap-md py-lg md:py-4xl lg:py-5xl xl:py-8xl flex-col'
            : '',
          {
            'md:w-screen md:flex-wrap': isEditorialTextFullWidth(
              logicWrapper.contents
            ),
          },
        ]"
      >
        <div
          v-for="(logic, index) in logicWrapper.contents"
          :key="`logic-wrapper-${index}`"
          :class="[
            `lg:${widthOptions[logic.dimension!]!} w-full content-center order-${logic.contentOrderMobile ? Number(logic.contentOrderMobile) - 1 : index} lg:order-${index}`,
            { 'md:flex-1': logic.content?.bgDesktopMedia },
          ]"
          :data-testid="
            logic.content &&
            logic.content._meta &&
            logic.content._meta.schema === 'https://armani.com/hero-banner'
              ? `banner-to-plp-${i}-${index}`
              : 'other-banner'
          "
        >
          <div
            v-if="
              logic.content && logic.content._meta && logic.content._meta.schema
            "
            :class="
              logic.padding
                ? paddingOptions[logic.alignment as PaddingOptionsType]
                : ''
            "
          >
            <component
              :is="editorialModulesMapping[logic.content!._meta.schema]"
              v-bind="logic.content!"
              :is-hero-banner="i === 0"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
